<div class="preview-dialog">

  <div class="preview-header">
    <span class="preview-title" [matTooltip]="fileName">{{ fileName }}</span>
    <button mat-icon-button (click)="close()" aria-label="Close preview">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-body">
    <img *ngIf="isImage" [src]="safeImageUrl" class="preview-image" [alt]="fileName">
    <iframe *ngIf="!isImage" [src]="safePdfUrl" class="preview-frame" title="Document preview"></iframe>
  </div>

</div>
